import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-background-50 text-primary-700 flex items-center justify-center">
                <i className="ri-links-line text-lg" />
              </span>
              <span className="font-heading font-semibold text-lg">USFansLink</span>
            </div>
            <p className="text-sm text-background-50/70 leading-relaxed">{t("footer.desc")}</p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50/60 mb-4">{t("footer.explore")}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-50/80 hover:text-background-50 transition-colors">{t("nav.home")}</Link></li>
              <li><Link to="/article/what-is-a-usfans-spreadsheet" className="text-sm text-background-50/80 hover:text-background-50 transition-colors">USFans Spreadsheet</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50/60 mb-4">{t("footer.categories")}</h4>
            <ul className="grid grid-cols-2 gap-2">
              {categories.map((c) => (
                <li key={c.id}>
                  <a
                    href={c.link}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-50/80 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {t(c.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/50">© {new Date().getFullYear()} USFansLink. {t("footer.rights")}</p>
          <p className="text-xs text-background-50/50 text-center max-w-md">{t("footer.disclaimer")}</p>
        </div>
      </div>
    </footer>
  );
}